import { render, staticRenderFns } from "./BoService.vue?vue&type=template&id=ae662fde&"
import script from "./BoService.vue?vue&type=script&lang=js&"
export * from "./BoService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports